const SkillsBadgeIcon = ({
  className,
  width = 12,
  height = 16,
}: {
  className?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.23131 8.91429L4.89994 6.7301L3.13744 5.32057H5.30006L6 3.09848L6.68756 5.32057H8.86256L7.09369 6.7301L7.74994 8.91429L6 7.5619L4.23131 8.91429ZM1.55006 16V10.1777C1.01669 9.60209 0.625 8.96299 0.375 8.26038C0.125 7.55765 0 6.83594 0 6.09524C0 4.37676 0.577063 2.93124 1.73119 1.75867C2.88544 0.586223 4.30838 0 6 0C7.69163 0 9.11456 0.586223 10.2688 1.75867C11.4229 2.93124 12 4.37676 12 6.09524C12 6.83594 11.875 7.55765 11.625 8.26038C11.375 8.96299 10.9833 9.60209 10.4499 10.1777V16L6 14.489L1.55006 16ZM6 10.9206C7.325 10.9206 8.44794 10.4529 9.36881 9.51752C10.2896 8.58203 10.7499 7.44127 10.7499 6.09524C10.7499 4.74921 10.2896 3.60844 9.36881 2.67295C8.44794 1.73759 7.325 1.2699 6 1.2699C4.675 1.2699 3.55206 1.73759 2.63119 2.67295C1.71044 3.60844 1.25006 4.74921 1.25006 6.09524C1.25006 7.44127 1.71044 8.58203 2.63119 9.51752C3.55206 10.4529 4.675 10.9206 6 10.9206ZM2.79994 14.1777L6 13.219L9.20006 14.1777V11.219C8.72081 11.5492 8.20519 11.7937 7.65319 11.9524C7.10106 12.1111 6.55 12.1905 6 12.1905C5.45 12.1905 4.89894 12.1111 4.34681 11.9524C3.79481 11.7937 3.27919 11.5492 2.79994 11.219V14.1777Z"
        fill="#001E2B"
      />
    </svg>
  );
};

export default SkillsBadgeIcon;
